import { Labeled } from '@components/form/Labeled'
import type { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Input } from '@/components/ui/input'

import { MoneyField, StepIntro, SwitchField } from './fields'
import type { SettlementFormValues } from './useSettlementInputsForm'

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Máj',
  'Jún',
  'Júl',
  'Aug',
  'Sep',
  'Okt',
  'Nov',
  'Dec'
]

export function StepHeat({
  form
}: {
  form: UseFormReturn<SettlementFormValues>
}) {
  const { t } = useTranslation('settlement')

  const useCoefficients = form.watch('use_coefficients')

  return (
    <div className="space-y-4">
      <StepIntro>{t('wizard.heat.intro')}</StepIntro>

      <div className="rounded-2xl border border-ink/[0.08] p-4">
        <h3 className="m-0 mb-3 font-display text-base font-bold text-ink">
          {t('sections.heat_water')}
        </h3>
        <div className="grid gap-4 sm:grid-cols-2">
          <MoneyField
            name="heat_water_price_per_m3"
            label={t('fields.heat_price_per_m3')}
            hint={t('hints.heat_price_per_m3')}
            suffix="€/m³"
            register={form.register}
          />
          <MoneyField
            name="heat_water_base_annual"
            label={t('fields.base_annual')}
            hint={t('hints.base_annual')}
            suffix="€"
            register={form.register}
          />
        </div>
      </div>

      <div className="rounded-2xl border border-ink/[0.08] p-4">
        <h3 className="m-0 mb-3 font-display text-base font-bold text-ink">
          {t('sections.heating')}
        </h3>
        <div className="grid gap-4 sm:grid-cols-2">
          <MoneyField
            name="heating_annual"
            label={t('fields.heating_annual')}
            hint={t('hints.heating_annual')}
            suffix="€"
            register={form.register}
          />
          <SwitchField
            name="use_coefficients"
            label={t('fields.use_coefficients')}
            hint={t('hints.coefficients')}
            control={form.control}
          />
        </div>

        {useCoefficients && (
          <div className="mt-4 grid grid-cols-3 gap-2 sm:grid-cols-6">
            {MONTHS.map((month, index) => (
              <Labeled key={month} label={month}>
                <Input
                  inputMode="decimal"
                  {...form.register(`heating_coefficients.${index}` as const)}
                />
              </Labeled>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
